<script>
    import { t } from "../../../lang/lang.js";

    const units = [
        'mm',
        'cm',
        'm',
    ];

    export let value;
</script>

<select class="arsize_select" bind:value={value}>
    {#each units as unit}
        <option value={unit}>{ t('unit.' + unit) }</option>
    {/each}
</select>

<style>
    option,
    select {
        box-sizing: border-box;
    }
    .arsize_select {
        width: 29%;
    }
    .arsize_select {
        display: block;
        padding: 5px;
        box-sizing: border-box;
        margin: 0;
        border: 2px solid #BEC7D2;
        border-left: 0;
        font-size: 20px;
        line-height: 1;
        font-weight: 500;
        box-shadow: none;
        border-radius: 0 10px 10px 0;
        -moz-appearance: none;
        -webkit-appearance: none;
        color: #7F8287;
        background: #fff url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02LjQxNjAzIDYuNDI3OThMNi40MTU5NSA2LjQyODA2QzYuMzA1ODEgNi41MzgzOCA2LjE1NjI0IDYuNjAwNyA1Ljk5OTk4IDYuNjAwN0M1Ljg0NDA0IDYuNjAwNyA1LjY5NDIxIDYuNTM4NzEgNS41ODM5NSA2LjQyNzk4TDYuNDE2MDMgNi40Mjc5OFpNNi40MTYwMyA2LjQyNzk4TDExLjAyODUgMS44MDI2OEwxMS4wMjg2IDEuODAyNjRDMTEuMjU3NSAxLjU3MjkgMTEuMjU3MSAxLjIwMSAxMS4wMjc0IDAuOTcxNzI3TDExLjAyNzQgMC45NzE2ODJDMTAuNzk3NiAwLjc0MjQ0NSAxMC40MjU0IDAuNzQzMDk4IDEwLjE5NjMgMC45NzI4MjhMMTAuMTk2MyAwLjk3MjgzMkw1Ljk5OTk4IDUuMTgwOEwxLjgwMzY1IDAuOTcyNjc5TDEuODAzNjIgMC45NzI2NTRDMS41NzQ1IDAuNzQyOTY4IDEuMjAyNTUgMC43NDIzMTQgMC45NzI3MzUgMC45NzE1MDhMMC45NzI2NzIgMC45NzE1NzJDMC44NTc2NjMgMS4wODYzNyAwLjggMS4yMzcyOSAwLjggMS4zODc2N0MwLjggMS41Mzc2MiAwLjg1NzI3MyAxLjY4Nzk5IDAuOTcxNTI1IDEuODAyNjJMMC45NzE1NjUgMS44MDI2Nkw1LjU4Mzc5IDYuNDI3ODFMNi40MTYwMyA2LjQyNzk4WiIgZmlsbD0iIzdGODI4NyIgc3Ryb2tlPSIjN0Y4Mjg3IiBzdHJva2Utd2lkdGg9IjAuNCI+PC9wYXRoPgo8L3N2Zz4=") no-repeat;
        background-position: right 14px top 50%, 0 0;
    }
    .arsize_select:hover {
        border-color: #4CC499;
    }
    .arsize_select:focus {
        border-color: #4CC499;
        box-shadow: none;
        color: #243955;
        outline: none;
    }
    .arsize_select option {
        font-weight: normal;
    }
</style>